// pages/settings/Settings.js
import { Outlet } from "react-router-dom";

export default function Settings() {
  return <Outlet />;
}